<template>
	<div v-if="accessory" class="accessory-card">
		<div class="accessory-image">
			<img :src="currentVariantImage" class="img-responsive">
		</div>
		<div class="accessory-content">
			<h6 class="accessory-title">
				{{ accessory.name }}
			</h6>
			<p class="accessory-description">
				{{ accessory.description }}
			</p>
			<color-picker
				v-if="isDifferentColors"
				:class="{ 'disable-element': isCartUpdating }"
				:is-selected="isSelected"
				:current-variant-id="currentVariantId"
				:variants="accessory.variants"
				@update-variant="update"
				@select-variant="setVariantId"
			/>
		</div>
		<div class="accessory-footer">
			<multiselect
				v-if="type === 'storage' && storageOptions"
				:class="{ 'disable-element': isCartUpdating }"
				:disabled="isCartUpdating"
				v-model="storage"
				:allow-empty="false"
				:custom-label="storageName"
				:options="storageOptions"
				:searchable="false"
				:show-labels="false"
				@input="selectStorage(storage.id)"
			/>
			<multiselect
				v-if="showMultiselect && type !== 'storage'"
				:class="{ 'disable-element': isCartUpdating }"
				:disabled="isCartUpdating"
				v-model="quantity"
				:allow-empty="false"
				:options="[1, 2, 3]"
				:searchable="false"
				:show-labels="false"
				@input="isSelected && update(currentVariantId)"
			/>
			<p class="accessory-price">{{ currentVariantPrice | formatMoney }}</p>
		</div>

		<template>
			<button
				v-if="!isSelected"
				type="button"
				:class="[
					'btn', 'btn-block', 'add-to-cart',
					{ 'disable-element': isCartUpdating }]"
				:disabled="isCartUpdating"
				@click="update(currentVariantId)"
			>
				ADD TO CART
			</button>
			<button
				v-else
				type="button"
				class="btn btn-block btn-purple btn-outline remove-from-cart"
				:class="[{ 'disable-element': isCartUpdating }]"
				:disabled="isCartUpdating"
				@click.once="remove"
			>
				REMOVE FROM CART
			</button>
		</template>
	</div>
</template>

<script>
import AccessoryFunctionalities from "../mixins/accessoryFunctionalities";
import ColorPicker from "./color-picker";

export default {
	name: "AccessoryCard",
	components: {
		ColorPicker
	},
	mixins: [
		AccessoryFunctionalities
	]
};
</script>

<style lang="scss" scoped>
.accessory-card {
    border-radius: 2px;
    background-color: #ffffff;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
    padding: 15px;
    margin-bottom: 30px;
    display: grid;
    grid-template-columns: auto;
    grid-template-areas:
        "image"
        "content"
        "footer"
        "cart";

    @media (max-width: 766px) {
        grid-template-columns: auto auto;
        grid-template-areas: "image content" "footer footer" "cart cart";
        column-gap: 10px;
    }

    .accessory-image {
        height: 280px;
        display: flex;
        align-items: center;
        justify-content: center;
        grid-area: image;

        @media (max-width: 992px) {
            height: 360px;
        }

        @media (max-width: 766px) {
            align-items: baseline;
            height: initial;
            width: 70px;
        }
    }

    .accessory-content {
        height: 170px;
        grid-area: content;

        @media (max-width: 766px) {
            height: initial;
            margin-bottom: 10px;
        }

        .accessory-title {
            color: #000000;
            font-size: 15px;
            font-weight: bold;
            line-height: 21px;
            margin-top: 0;
            margin-bottom: 0;
        }

        .accessory-description {
            color: #5f707f;
            font-size: 15px;
            line-height: 21px;
            margin-bottom: 0;
        }

        .more-info {
            color: #51007a;
            font-size: 15px;
            line-height: 21px;
            text-transform: uppercase;
            white-space: pre;
        }
    }

    .accessory-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        grid-area: footer;
        border-top: 1px solid #dadde0;
        min-height: 75px;

        .accessory-price {
            color: #444259;
            font-size: 15px;
            font-weight: bold;
            line-height: 19px;
            margin-bottom: 0;
            margin-left: auto;
        }
    }

    .btn {
        grid-area: cart;
        transition: none;
    }

    .add-to-cart {
        background-color: #51007a;
        color: white;
    }

    .remove-from-cart {
        border-color: #51007a;
        color: #51007a;
        padding-left: 0;
        padding-right: 0;
    }
}

</style>

<style lang="scss">
.accessory-card {
    .multiselect {
        width: auto;
        &__select {
            width: 26px;
        }

        &__option--highlight {
            background: #51007a;
            outline: none;
            color: #fff;
        }
        &__option--selected {
            &.multiselect__option--highlight {
                background: #f3f3f3;
                color: #35495e;
                cursor: default;
            }
        }
    }
}
</style>
